<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.1666 6.66666L8.50094 9.48258L5.83331 6.66666" stroke="#8d94a5" stroke-miterlimit="10"/>
</svg>
